import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { ImgThumbPipe } from './img-thumb.pipe';
import { NumberFormatterPipe } from './number-formatter';
import { EsgStatusPipe } from './esg-status.pipe';
const pipes = [ExcerptPipe, GetValueByKeyPipe, RelativeTimePipe, ImgThumbPipe, NumberFormatterPipe, EsgStatusPipe];

@NgModule({
	imports: [CommonModule],
	declarations: pipes,
	exports: pipes
})
export class SharedPipesModule {}
